import CoursesItemsService from "@/services/CoursesItemsService";
import { UserFactory } from "@/classes/abstractFactory";

function getInitState() {
  return {
    currentCourseId: null,
    courseName: "",
    teacher: {},
    lessons: [],
    journal: {},
  };
}
class Lesson {
  constructor(rawLesson, index) {
    const { className, label } = this.calcDisplayData(
      rawLesson.status,
      rawLesson.evaluation_result
    );
    this.index = index;
    this.id = rawLesson.id;
    this.status = rawLesson.status;
    this.statusLabel = label;
    this.className = className;
    this.name = rawLesson.name;
    this.hasMessages = rawLesson.has_messages;
    this.evaluation = rawLesson.evaluation_result || "";
  }

  calcDisplayData(status, rawEvaluation) {
    let evaluation = rawEvaluation ? parseInt(rawEvaluation, 10) : 12;
    evaluation = isNaN(evaluation) ? -1 : evaluation;
    switch (status) {
      case 0:
        return { className: "not-started", label: "" };
      case 1:
        return { className: "in-progress", label: "на вивченні" };
      case 2:
        return { className: "need-check", label: "на перевірці" };
      case 3:
        if (evaluation >= 4) {
          return { className: "finished", label: "зараховано" };
        }
        return { className: "not-confirmed", label: "незадовільно" };
      case 4:
        return { className: "need-rework", label: "треба доробити" };
      default:
        return { className: "not-started", label: "" };
    }
  }
}

const getters = {
  getCourseName: (state) => {
    return state.courseName;
  },
  getTeacher: (state) => {
    return state.teacher;
  },
  getJournal: (state) => {
    return state.journal;
  },
  getLessons: (state) => {
    return state.lessons;
  },

  getCurrentCourseId: (state) => {
    return state.currentCourseId;
  },
};

const actions = {
  async loadLessons({ commit }, payload) {
    const { courseId } = payload;
    const lessonResponse = await CoursesItemsService.getLessons(courseId);
    const lessons = lessonResponse.data.lessons;
    const lessonsNames = lessonResponse.data.schemas;
    const evaluations = lessonResponse.data.lesson_evaluations;
    const teacher = lessonResponse.data.teacher;
    const name = lessonResponse.data.name;

    commit("setCourseName", name);
    commit("setTeacher", teacher);
    commit("setCourseId", courseId);
    commit("setLessons", lessons);
    commit(
      "TeacherRoomStore/setJournal",
      {
        students: [
          {
            first_name: "",
            last_name: "",
            evaluations,
          },
        ],
        lessons: lessonsNames,
      },
      { root: true }
    );
  },
};

function createTeacher(rawUser) {
  const builder = UserFactory.getUserBuilder();
  const user = builder
    .setFirstName(rawUser.first_name)
    .setLastName(rawUser.last_name)
    .setEmail(rawUser.email)
    .setUserId(rawUser.id)
    .seRole(rawUser.role)
    .setGrade(rawUser.grade)
    .setGuest(rawUser.guest)
    .build();
  return user;
}

const mutations = {
  resetStore(state) {
    const initState = getInitState();
    Object.keys(initState).forEach((key) => {
      state[key] = initState[key];
    });
  },

  setCourseName(state, courseName) {
    state.courseName = courseName;
  },
  setTeacher(state, teacher) {
    state.teacher = createTeacher(teacher);
  },
  setCourseId(state, courseId) {
    state.currentCourseId = parseInt(courseId);
  },
  setLessons(state, rawLessons) {
    state.lessons = rawLessons.map((rawLesson, index) => {
      return new Lesson(rawLesson, index);
    });
  },
  setJournal(state, journal) {
    state.journal = journal;
  },
};

export default {
  namespaced: true,
  state: getInitState(),
  getters,
  actions,
  mutations,
};
